enum NodeType {
  Page = 'Page',
  User = 'User',
  Event = 'Event',
  Donation = 'Donation',
  Charity = 'Charity',
  Timeline = 'Timeline',
  ImageMedia = 'ImageMedia',
  VideoMedia = 'VideoMedia',
  LivestreamMedia = 'LivestreamMedia',
  AuctionLot = 'AuctionLot',
}

function decodeNodeId(
  nodeId: string,
): { type: NodeType; parts: string[]; decoded: string } {
  const decoded = Buffer.from(nodeId, 'base64').toString();
  const [type, ...parts] = decoded.split(':');

  return { type: type as NodeType, parts, decoded };
}

export default decodeNodeId;
